import React, { useState, Fragment } from 'react';
import { useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
interface MenuItem {
  title: string;
  url: string;
  children?: {
    title: string;
    url: string;
  }[];
}
const menuItems: MenuItem[] = [{
  title: 'Home',
  url: '/'
}, {
  title: 'Services',
  url: '/services',
  children: [{
    title: 'Mobile App Development',
    url: '/services/mobile-apps'
  }, {
    title: 'Custom Web Development',
    url: '/services/web-development'
  }, {
    title: 'Embedded Systems',
    url: '/services/embedded-systems'
  }, {
    title: 'Database Solutions',
    url: '/services/database-solutions'
  }, {
    title: 'High Availability',
    url: '/services/high-availability'
  }, {
    title: 'Global File System',
    url: '/services/global-file-system'
  }]
}, {
  title: 'AI & Automation',
  url: '/ai-automation'
}, {
  title: 'Project Support',
  url: '/support'
}, {
  title: 'About',
  url: '/about'
}, {
  title: 'Contact',
  url: '/contact'
}];
export function MobileMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  function toggle() {
    setIsOpen(prev => !prev);
  }
  function isActive(path: string): boolean {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  }
  return <>
      {/* Hamburger / Close Button */}
      <button className="md:hidden p-2 text-white" onClick={toggle} aria-label="Toggle menu" data-id="element-103">
        {isOpen ? <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-104">
            <line x1="18" y1="6" x2="6" y2="18" data-id="element-105" />
            <line x1="6" y1="6" x2="18" y2="18" data-id="element-106" />
          </svg> : <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-107">
            <line x1="3" y1="12" x2="21" y2="12" data-id="element-108" />
            <line x1="3" y1="6" x2="21" y2="6" data-id="element-109" />
            <line x1="3" y1="18" x2="21" y2="18" data-id="element-110" />
          </svg>}
      </button>

      {/* Mobile Menu Panel */}
      <AnimatePresence data-id="element-111">
        {isOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.2
      }} className="md:hidden border-t border-divider bg-header absolute left-0 right-0 top-full" data-id="element-112">
            <nav className="flex flex-col px-4 py-4 gap-1" data-id="element-113">
              {menuItems.map(item => <Fragment key={item.title} data-id="element-114">
                  <a href={item.url} onClick={toggle} className={`px-4 py-3 rounded-lg text-base font-medium transition-colors ${isActive(item.url) ? 'bg-deep text-white' : 'text-blue-200 hover:bg-deep hover:text-white'}`} data-id="element-115">
                    {item.title}
                  </a>

                  {item.children && item.children.length > 0 && <div className="pl-6 flex flex-col gap-1" data-id="element-116">
                      {item.children.map(child => <a key={child.url} href={child.url} onClick={toggle} className="flex items-center gap-2 px-4 py-2 rounded-lg text-sm text-blue-200 hover:bg-deep hover:text-white transition-colors" data-id="element-117">
                          {child.title}
                        </a>)}
                    </div>}
                </Fragment>)}

              <div className="mt-2" data-id="element-118">
                <a href="tel:231-266-0606" className="w-full inline-flex items-center justify-center px-6 py-3 text-base font-semibold rounded-lg border-2 border-white text-white hover:bg-deep transition-all duration-200 cursor-pointer" data-id="element-119">
                  231-266-0606
                </a>
              </div>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </>;
}